/**
 * admin_table_filter_controller.js — filter a table's rows as you type (Stimulus).
 *
 * Hides every row of the body target whose text does not contain the input's
 * text (case-insensitive). The rows stay in the DOM; nothing is fetched.
 *
 * Targets: input (the search box, data-action="input->admin-table-filter#filter"),
 * body (the <tbody> whose rows are filtered).
 *
 * Template: templates/admin/promo_agent_detail.html (the agent's QR codes)
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ['input', 'body'];

    filter() {
        if (!this.hasBodyTarget) return;  // the table renders only when it has rows
        const term = this.inputTarget.value.toLowerCase().trim();
        Array.from(this.bodyTarget.rows).forEach(function (row) {
            row.style.display = row.textContent.toLowerCase().includes(term) ? '' : 'none';
        });
    }
}
